module.exports = __webpack_public_path__ + "static/FutureImages-f83d492fa78a34b6d4cad38b02c726e6.jpg";